var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaletteICon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "\\uB808\\uC774\\uC5B4_2",
    width: 20,
    height: 20,
    viewBox: "0 0 19.944 17.937",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc-paletteIcon"
  }, " \uC0C9\uC0C1 ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .palette{fill:#b9b9b9}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4103",
    d: "M31.3 18.914a1.647 1.647 0 1 1 1.642-1.627 1.647 1.647 0 0 1-1.642 1.627zm0-2.308a.661.661 0 1 0 .471.2.661.661 0 0 0-.471-.2z",
    className: "palette",
    transform: "translate(-15.027 -7.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4104",
    d: "M31.3 18.914a1.647 1.647 0 1 1 1.642-1.627 1.647 1.647 0 0 1-1.642 1.627zm0-2.308a.661.661 0 1 0 .471.2.661.661 0 0 0-.471-.2z",
    className: "palette",
    transform: "translate(-15.027 -7.917)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4105",
    d: "M22.731 25.9a2.131 2.131 0 1 1 2.131-2.111 2.13 2.13 0 0 1-2.131 2.111zm0-3.27a1.144 1.144 0 1 0 .814.34 1.144 1.144 0 0 0-.814-.339z",
    className: "palette",
    transform: "translate(-10.441 -10.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4106",
    d: "M26.492 11.054A1.652 1.652 0 1 1 28.144 9.4a1.652 1.652 0 0 1-1.652 1.652zm0-2.313a.661.661 0 1 0 .47.192.666.666 0 0 0-.47-.192z",
    className: "palette",
    transform: "translate(-12.59 -3.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4107",
    d: "M16.977 8.664A1.652 1.652 0 1 1 18.6 7.012a1.652 1.652 0 0 1-1.627 1.652zm0-2.313a.666.666 0 1 0 .641.661.666.666 0 0 0-.641-.661z",
    className: "palette",
    transform: "translate(-7.754 -2.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4108",
    d: "M8.442 12.874a1.652 1.652 0 1 1 1.652-1.652 1.652 1.652 0 0 1-1.652 1.652zm0-2.313a.661.661 0 1 0 .47.192.666.666 0 0 0-.47-.192z",
    className: "palette",
    transform: "translate(-3.441 -4.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4109",
    d: "M9.972 17.937h-.138a2.081 2.081 0 0 1-1.553-.715 2.313 2.313 0 0 1-.542-1.78A4.207 4.207 0 0 0 7.4 13.2c-.853-1.884-3.1-2.959-5.731-2.712a1.578 1.578 0 0 1-1.176-.398A1.45 1.45 0 0 1 0 9.015C0 4.024 4.473 0 9.972 0s9.972 4.024 9.972 8.971-4.473 8.966-9.972 8.966zM2.407 9.464a6.249 6.249 0 0 1 5.918 3.329 5.188 5.188 0 0 1 .409 2.762 1.307 1.307 0 0 0 .3 1.016 1.11 1.11 0 0 0 .824.38h.128c4.956 0 8.986-3.58 8.986-7.98s-4.044-7.985-9-7.985S.986 4.567.986 8.971a.493.493 0 0 0 .158.385.587.587 0 0 0 .449.148c.276-.025.547-.04.814-.04z",
    className: "palette",
    transform: "translate(0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaletteICon);
export default __webpack_public_path__ + "static/media/PaletteICon.0515b36c.svg";
export { ForwardRef as ReactComponent };